import type HotkeysMapStore from './schema/HotkeysMapStore';
import { createStore } from 'owa-satcheljs';

const initialHotkeysMapStore: HotkeysMapStore = {
    isVisible: false,
    commandCategories: [],
    hotkeyCommands: [],
};

const store: () => HotkeysMapStore = createStore<HotkeysMapStore>(
    'HotkeysMapStore',
    initialHotkeysMapStore
);
export default store;
